import { REQUEST_FAIL } from 'reducers/modal/actions';

export const SET_SIDEPANEL = 'SET_SIDEPANEL';
export const REVERT_SIDEPANEL = 'REVERT_SIDEPANEL';
export const CLOSE_SIDEPANEL = 'CLOSE_SIDEPANEL';

const allowedSidePanelProperties = [
  'id',
  'sfdi',
  'entity',
  'state',
  'keepBreadcrumbs',
  'backBehavior',
  'selectedOnTreeMap',
  'data'
];

export const setSidePanel = sidePanelInfo => async (dispatch, getState) => {
  try {
    for (let property in sidePanelInfo) {
      if (!allowedSidePanelProperties.includes(property)) {
        throw new Error(
          `${property} not an allowed property in the setSidePanel action creator.`
        );
      }
    }

    const oldSidePanelInfo = getState().sidePanel;
    const updatedSidePanelInfo = {
      ...sidePanelInfo,
      displaySidePanel: true,
      breadcrumbs: []
    };
    delete updatedSidePanelInfo.keepBreadcrumbs;

    //If we are to persist the previous sidePanel into the breadcrumbs array.
    if (oldSidePanelInfo.displaySidePanel && sidePanelInfo.keepBreadcrumbs) {
      const {
        id,
        sfdi,
        entity,
        state,
        breadcrumbs,
        backBehavior,
        selectedOnTreeMap
      } = oldSidePanelInfo;
      const newBreadcrumbInfo = [
        { id, sfdi, entity, state, backBehavior, selectedOnTreeMap }
      ];
      const newBreadcrumbs =
        breadcrumbs.length > 0
          ? breadcrumbs.concat(newBreadcrumbInfo)
          : newBreadcrumbInfo;
      updatedSidePanelInfo.breadcrumbs = newBreadcrumbs;
    }
    return dispatch({
      type: SET_SIDEPANEL,
      data: updatedSidePanelInfo
    });
  } catch (err) {
    dispatch({
      type: REQUEST_FAIL,
      message: `Error in retrieving data for this ${sidePanelInfo.entity}`
    });
    throw err;
  }
};

export const revertSidePanel = data => async (dispatch, getState) => {
  try {
    const { sidePanel } = getState();
    const { breadcrumbs } = sidePanel;
    if (breadcrumbs && breadcrumbs.length > 0) {
      const newBreadcrumbs = breadcrumbs.slice();
      const lastBreadcrumb = newBreadcrumbs.pop();
      const newSidePanelInfo = {
        ...lastBreadcrumb,
        data,
        breadcrumbs: newBreadcrumbs
      };
      return dispatch({
        type: REVERT_SIDEPANEL,
        data: newSidePanelInfo
      });
    } else {
      return dispatch({
        type: CLOSE_SIDEPANEL
      });
    }
  } catch (err) {
    const { sidePanel } = getState();
    const { breadcrumbs } = sidePanel;
    let errorModalMessage = `Error in going back`;
    if (breadcrumbs && breadcrumbs.length > 0) {
      errorModalMessage = `Error in retrieving data for this ${
        breadcrumbs[breadcrumbs.length - 1].entity
      }`;
    }
    dispatch({
      type: REQUEST_FAIL,
      message: errorModalMessage
    });
    throw err;
  }
};

export const closeSidePanel = () => async (dispatch, getState) => {
  try {
    return dispatch({
      type: CLOSE_SIDEPANEL
    });
  } catch (err) {
    const { sidePanel } = getState();
    dispatch({
      type: REQUEST_FAIL,
      message: `Error in closing the ${sidePanel.entity} panel`
    });
    throw err;
  }
};
